// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__-5mu7","logo":"Logo_logo__vDBPO","logo24":"Logo_logo24__18E6b","logo36":"Logo_logo36__yXrz1","logo48":"Logo_logo48__bK5oy","logoSVG":"Logo_logoSVG__XrMdm"};